import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '@cart/const';
import { Cart, ConverterService, Occ, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { CART_NORMALIZER } from '../converters';

@Injectable({
  providedIn: 'root',
})
export class SavedCartApiService {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
  ) {}

  load(cartId: string): Observable<Cart> {
    return (
      this.http
        .get<Occ.Cart>(this.getSavedCartEndpoint(cartId))
        // eslint-disable-next-line deprecation/deprecation
        .pipe(pluck('savedCartData'), this.converter.pipeable(CART_NORMALIZER))
    );
  }

  loadList(): Observable<Cart[]> {
    return this.http.get<Occ.CartList>(this.getSavedCartListEndpoint()).pipe(
      // eslint-disable-next-line deprecation/deprecation
      pluck('carts'),
      map((carts) => carts ?? []),
      this.converter.pipeableMany(CART_NORMALIZER),
    );
  }

  cloneSavedCart(userId: string, cartId: string, saveCartName: string): Observable<Cart> {
    return (
      this.http
        .post<Occ.Cart>(this.getCloneSavedCartEndpoint(userId, cartId, saveCartName), cartId)
        // eslint-disable-next-line deprecation/deprecation
        .pipe(pluck('savedCartData'), this.converter.pipeable(CART_NORMALIZER))
    );
  }

  protected getSavedCartEndpoint(cartId: string): string {
    return this.occEndpoints.buildUrl('savedCart', {
      urlParams: { cartId },
    });
  }

  protected getSavedCartListEndpoint(): string {
    return this.occEndpoints.buildUrl(API_ENDPOINTS.savedCarts);
  }

  protected getRestoreSavedCartEndpoint(userId: string, cartId: string): string {
    return this.occEndpoints.buildUrl('restoreSavedCart', {
      urlParams: { userId, cartId },
    });
  }

  protected getCloneSavedCartEndpoint(userId: string, cartId: string, saveCartName: string): string {
    return this.occEndpoints.buildUrl('cloneSavedCart', {
      urlParams: { userId, cartId, saveCartName },
    });
  }
}
